const searchFieldOptions = [
  { label: 'DeviceID', value: 'DeviceID' },
  { label: 'Module-IMEI', value: 'ModuleIMEI' },
  { label: 'Module-SN', value: 'ModuleSN' },
  { label: 'SIM-ICCID', value: 'SIMICCID' },
  { label: 'SIM-IMEI', value: 'SIMIMEI' },
  { label: 'Status', value: 'Status' },
  { label: 'RcvTime', value: 'RcvTime' },
]

const searchFieldOperation = {
  'DeviceID': 'Contains',
  'ModuleIMEI': 'Contains',
  'ModuleSN': 'Contains',
  'SIMICCID': 'Contains',
  'SIMIMEI': 'Contains',
  'Status': 'Contains',
  'RcvTime': 'Contains'
}

export {searchFieldOptions,searchFieldOperation}



// WEBPACK FOOTER //
// ./src/views/device/options.js